var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0032 17.0021H15.5367C15.2023 17.002 14.89 17.1691 14.7044 17.4473L14.2982 18.0565C14.1126 18.3347 13.8003 18.5017 13.4659 18.5017H8.53382C8.1994 18.5017 7.88707 18.3347 7.70147 18.0565L7.2953 17.4473C7.10929 17.169 6.79665 17.002 6.46195 17.0021H2.99651C2.44408 17.0023 1.99629 17.4501 1.99609 18.0025V19.0029C1.99609 19.5336 2.2067 20.0426 2.58196 20.4179C2.95722 20.7931 3.46623 21.0039 3.99693 21.0037H18.0028C18.5335 21.0039 19.0425 20.7931 19.4177 20.4179C19.793 20.0426 20.0036 19.5336 20.0036 19.0029V18.0025C20.0034 17.4501 19.5556 17.0023 19.0032 17.0021V17.0021Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0031 17.002V13.0004",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.501 9.99918V11.4988C14.501 11.6919 14.6121 11.8677 14.7865 11.9506C14.9608 12.0335 15.1673 12.0086 15.317 11.8867L17.6349 9.99918H20.0033C21.1083 9.99918 22.0041 9.10338 22.0041 7.99835V3.99668C22.0041 2.89165 21.1083 1.99585 20.0033 1.99585H13.0003C11.8953 1.99585 10.9995 2.89165 10.9995 3.99668V7.99835C10.9995 9.10338 11.8953 9.99918 13.0003 9.99918H14.501Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99658 17.0021V6.9979C2.99644 6.46721 3.20719 5.9582 3.58245 5.58294C3.95771 5.20768 4.46672 4.99692 4.99742 4.99707H7.99867",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.7b2f49f5d5ae1ee89a0b88d40c13b105.svg";
export { ForwardRef as ReactComponent };